<template>
  <div class="member-permis-page">
    <div class="page-title">权限管理</div>
    <pageTable
      :col='columns'
      :data='list'
      :showPage='false'
      :rowHeight='50'
    ></pageTable>
  </div>
</template>
<script>
import { memberPermissionList } from '@/api/member'
import pageTable from '@/components/pageCom/pageTable'
import Vue from 'vue'
export default {
  name: 'memberPermission',
  components: { pageTable },
  data() {
    return {
      list: [],
      columns: [
        { field: 'step', title: '会员等级', width: 70, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'content', title: '权限', width: 740, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'hobby', title: '操作', width: 70, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'memPerOpe' }
      ]
    }
  },
  mounted() {
    memberPermissionList().then(res => {
      if (res.code === 0) {
        const compare = ['免费会员', '初级会员', '中级会员', '高级会员']
        res.result.forEach((item, index) => {
          this.list.push({
            step: compare[index],
            content: item.join(',')
          })
        })
      } else if (res.code !== 10008) {
        this.list = []
        this.$Message.info(res.msg)
      }
    })
  }
}
Vue.component('memPerOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    receipt() {
      this.$router.push({
        name: 'memberReEdit',
        params: { id: this.index }
      })
    }
  },
  render: function(h) {
    return h('span', {
      class: {
        operate: true
      },
      on: {
        click: this.receipt
      }
    }, '编辑')
  }
})
</script>
<style lang="scss">
  .member-permis-page {
    .page-title {
      margin-top: 10px;
      color: #5D6F80;
      font-size: 16px;
      width: 65px;
      height: 16px;
      line-height: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
    }
    .v-table-header-row {
      background: rgba(239,243,245,1);
      color: #5D6F80;
      font-size: 12px;
      font-weight: 500;
      font-family: PingFangSC-Medium;
    }
    tbody {
      .v-table-row {
        &:nth-child(2n) {
          background: rgba(243,246,248,1);
        }
      }
      .v-table-title-cell {
        padding: 0 10px;
      }
      .v-table-body-cell {
        border: none;
        padding: 0 10px;
      }
    }
    .operate {
      color: #1881DC;
      cursor: pointer;
    }
  }
</style>
